const features = [
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    desc: '告别翻页打断阅读节奏，手指轻轻下滑，漫画内容一气呵成。原生下拉式引擎，加载迅速、滑动流畅，给你纸质书般的沉浸感。',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: '完全免费',
    desc: '全站漫画资源永久免费，无需充值、无需会员。我们坚信好漫画应该被所有人看到，不设任何付费门槛，纯享阅读乐趣。',
  },
  {
    icon: 'ri-rocket-line',
    title: '极速更新',
    desc: '每日追踪50+部热门连载漫画更新，第一时间同步发布。设置追更提醒，绝不错过心仪作品的最新一话，追漫快人一步。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净无广告',
    desc: '专注阅读体验，拒绝弹窗和干扰广告。全站页面简洁清爽，让你沉浸在漫画世界中不受打扰，享受纯粹的阅读时光。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            亲亲漫画网为什么成为百万读者的首选下拉式漫画阅读平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/70 hover:border-primary-200 transition-all duration-300 text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-2xl bg-primary-50 flex items-center justify-center transition-colors duration-300 group-hover:bg-primary-100">
                <i className={`${item.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}